import { isNil } from "../utils/Utils";
export class RoleInfo {
    constructor(accountId, role) {
        this.rolesByTenantId = new Map();
        this.accountId = accountId;
        if (!isNil(role)) {
            this.role = role;
        }
    }
}
